import WizardIntegration = ToroEnums.WizardIntegration;
import WidgetType = ToroEnums.WidgetType;

import { Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BroadcastService } from '../../../../../common/services/broadcast.service';
import { I3OpenWorkOrders } from '../../../../../api/intelli360/models/i3-open-work-orders.model';
import { Intelli360ManagerService } from '../../../../../api/intelli360/intelli360-manager.service';
import { MyTurfManagerService } from '../../../../../api/my-turf/my-turf-manager.service';
import { take } from 'rxjs/operators';
import { ToroEnums } from '../../../../../common/enumerations/toro.enums';

@UntilDestroy()
@Component({
    selector: 'toro-intelli360-integration',
    templateUrl: './intelli360-integration.component.html',
    styleUrls: ['./intelli360-integration.component.less']
})
export class Intelli360IntegrationComponent implements OnInit, OnDestroy {
    @HostBinding('class') class = 'wiz-integration-component';

    @Output() canConnect = new EventEmitter<boolean>();
    @Output() configured = new EventEmitter<WizardIntegration>();

    private readonly maxValidationCount = 5;
    readonly stepsCount = 2;
    validationAttemptCount = 0;

    // =========================================================================================================================================================
    // Ctor and Lifecycle Hooks
    // =========================================================================================================================================================

    constructor(private broadcastService: BroadcastService,
                private intelli360Manager: Intelli360ManagerService,
                private myTurfManager: MyTurfManagerService
    ) { }

    ngOnInit(): void {
        this.broadcastService.setupDoConnect
            .pipe(untilDestroyed(this))
            .subscribe(() => this.onNavigateToSite());

        this.canConnect.emit(true);

        this.validateConnection();
    }

    ngOnDestroy() {
        this.canConnect.emit(false);
    }

    // =========================================================================================================================================================
    // Event Handler
    // =========================================================================================================================================================

    onNavigateToSite() {
        // // Select both of the myTurf widgets. The assumption is that since we are configuring them, the user will want them.
        // // They can still disable them on the enable/disable pane.
        // this.broadcastService.setupToggleWidgetState.next({ type: WidgetType.MyTurfMaintenance, isEnabled: true });
        // this.broadcastService.setupToggleWidgetState.next({ type: WidgetType.MyTurfOrders, isEnabled: true });
        // this.configured.next(WizardIntegration.MyTurf);

        // Navigate to site in the same browser so that the myTurf redirect will come back to the same window.
        this.broadcastService.toggleSystemOverlay.next({ show: true, text: 'STRINGS.NAVIGATING_TO_MY_TURF_SITE' });
        setTimeout(() => window.open(this.myTurfManager.myTurfLoginUrl, '_self'), 1000);
        setTimeout(() => this.broadcastService.toggleSystemOverlay.next({ show: false }), 2000);
    }

    private validateConnection() {

        this.intelli360Manager.getOpenWorkOrders()
            .pipe(take(1))
            .subscribe({
                next: (response: I3OpenWorkOrders) => {
                    // Select all the Intelli360 widgets. The assumption is that since we are configuring them, the user will want them.
                    // They can still disable them on the enable/disable pane.
                    this.broadcastService.setupToggleWidgetState.next({ type: WidgetType.Intelli360Maintenance, isEnabled: true });
                    this.broadcastService.setupToggleWidgetState.next({ type: WidgetType.Intelli360AssetDown, isEnabled: true });
                    this.broadcastService.setupToggleWidgetState.next({ type: WidgetType.Intelli360WorkOrders, isEnabled: true });
                    this.broadcastService.setupToggleWidgetState.next({ type: WidgetType.Intelli360OperatingStatus, isEnabled: true });

                    this.configured.next(WizardIntegration.Intelli360);
                },
                error: () => {
                    if (++this.validationAttemptCount <= this.maxValidationCount) {
                        setTimeout(() => this.validateConnection(), 60 * 1000);
                    }
                }
            })

    }

}
